import React, { useEffect } from "react";
import "./organization-overview.scss";
import OrganizationDetailHero from "./organization-detail-hero";
import {
  GSItemList,
  GSInfoCard,
  GSSidePanel,
  GSListPage,
} from "golfstatus_react_components";
import { connect, useDispatch } from "react-redux";
import OrganizationTournament from "./organization-tournament";
import {
  getOrganizationTournaments,
  getOrganizationPastTournaments,
  selectOrganization,
} from "../../reducers/organizationSlice";
import { useMatch } from "react-router-dom";
import { getOrgPages } from "../../forms/OrganizationForm";
import NavigationListItem from "../navigation-list-item";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import OrganizationEdit from "./organization-edit";

const OrganizationOverview = (props) => {
  const editOrganization = () => {
    navigate("settings");
  };
  const dispatch = useDispatch();
  const match = useMatch("/:id/*");
  const navigate = useNavigate();
  const {
    selectedOrganization,
    selectedOrganizationPastTournaments,
    selectedOrganizationTournaments,
    loading,
  } = props;

  const loadData = useCallback(() => {
    dispatch(getOrganizationTournaments(match?.params?.id));
    dispatch(getOrganizationPastTournaments(match?.params?.id));
    dispatch(selectOrganization(match?.params?.id));
  }, [dispatch, match?.params?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const isEdit = () => {
    return match.params["*"] === "edit";
  };

  const getTournamentLayout = (tournament) => {
    return <OrganizationTournament tournament={tournament} />;
  };
  const tournamentSelected = (tournament) => {
    window.open(
      `${process.env.REACT_APP_GOLFSTATUS_TMS_URL}/${tournament.id}`
    );
  };
  const hasTournaments = () => {
    return selectedOrganizationTournaments?.length > 0;
  };
  const hasPastTournaments = () => {
    return selectedOrganizationPastTournaments?.length > 0;
  };
  const getTournamentList = () => {
    return (
      <div className="tournament-list">
        <GSItemList
          type="horizontal large-gap large-pad"
          items={selectedOrganizationTournaments}
          itemSelected={tournamentSelected}
          listItem={(tourney) => (
            <GSInfoCard
              size="large"
              selectable={true}
              layout={getTournamentLayout(tourney)}
            ></GSInfoCard>
          )}
          loading={loading?.includes?.("getOrganizationTournaments")}
        ></GSItemList>
      </div>
    );
  };
  const getPastTournamentList = () => {
    return (
      <div className="tournament-list">
        <GSItemList
          type="horizontal large-gap large-pad"
          items={selectedOrganizationPastTournaments}
          itemSelected={tournamentSelected}
          listItem={(tourney) => (
            <GSInfoCard
              size="large"
              selectable={true}
              layout={getTournamentLayout(tourney)}
              loading={loading?.includes?.("getOrganizationPastTournaments")}
            ></GSInfoCard>
          )}
        ></GSItemList>
      </div>
    );
  };
  const getLinks = () => {
    return (
      <GSItemList
        type="vertical"
        itemSelected={itemSelected}
        items={getOrgPages()}
        listItem={(page) => getOrgPageLayout(page)}
      ></GSItemList>
    );
  };
  const getOrgPageLayout = (page) => {
    return <NavigationListItem page={page} />;
  };
  const itemSelected = (item) => {
    navigate(`${item.url}`);
  };
  return (
    <organization-overview>
      <div className={`overview-content ${isEdit() ? "blur" : ""}`}>
        <OrganizationDetailHero
          organization={selectedOrganization}
          editClicked={editOrganization}
        />
        {hasTournaments() && (
          <GSListPage
            title="Upcoming Tournaments"
            getItemList={getTournamentList}
          />
        )}
        {hasPastTournaments() && (
          <GSListPage
            title="Past Tournaments"
            getItemList={getPastTournamentList}
          />
        )}
        {getLinks()}
      </div>
      {isEdit() && (
        <GSSidePanel sidePanelOpen={isEdit()} children={<OrganizationEdit />} />
      )}
    </organization-overview>
  );
};

const mapStateToProps = (state) => ({
  selectedOrganization: state.orgs.selectedOrganization,
  selectedOrganizationTournaments: state.orgs.selectedOrganizationTournaments,
  selectedOrganizationPastTournaments:
    state.orgs.selectedOrganizationPastTournaments,
  loading: state.orgs.loading,
});

export default connect(mapStateToProps)(OrganizationOverview);
